<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { api } from '$lib/api/client';

  export let src: string | null;
  export let alt: string;
  export let editable = false;
  export let size = 'lg';

  const dispatch = createEventDispatcher<{
    change: string;
  }>();

  let uploading = false;
  let fileInput: HTMLInputElement;

  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32',
  };

  function handleClick() {
    if (editable) {
      fileInput.click();
    }
  }

  async function handleFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    uploading = true;

    try {
      const result = await api.upload.image(file, 'icon');
      dispatch('change', result.url);
    } catch (error) {
      console.error('Failed to upload avatar:', error);
    } finally {
      uploading = false;
      input.value = '';
    }
  }
</script>

<div class="relative">
  <button
    type="button"
    class="relative rounded-full overflow-hidden {sizeClasses[size]} {editable ? 'cursor-pointer hover:opacity-80' : ''}"
    disabled={!editable || uploading}
    on:click={handleClick}
  >
    {#if src}
      <img
        {src}
        {alt}
        class="w-full h-full object-cover"
      />
    {:else}
      <div class="w-full h-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-white text-2xl font-bold">
        {alt.charAt(0).toUpperCase()}
      </div>
    {/if}

    {#if editable}
      <div class="absolute inset-0 bg-black/0 hover:bg-black/30 transition-colors flex items-center justify-center">
        <span class="text-white opacity-0 hover:opacity-100 text-xs font-medium">
          変更
        </span>
      </div>
    {/if}

    {#if uploading}
      <div class="absolute inset-0 bg-black/50 flex items-center justify-center">
        <div class="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      </div>
    {/if}
  </button>

  <input
    bind:this={fileInput}
    type="file"
    accept="image/jpeg,image/png,image/webp,image/gif"
    class="hidden"
    on:change={handleFileChange}
  />
</div>
